import { CSSProperties, memo } from 'react';
import { createUseStyles } from 'react-jss';
import { DateTime } from 'luxon';
import cn from 'classnames';

type ExpirationProps = {
  className?: string,
  style?: CSSProperties
  value?: string | null,
};

const Expiration = (props: ExpirationProps) => {
  const {
    className,
    style,
    value,
  } = props;

  const classes = useStyles();

  if (!value || typeof value !== 'string') {
    return (
      <div className={cn(classes.expirationComponent, className)} style={style}>&nbsp;</div>
    );
  }

  return (
    <div className={cn(classes.expirationComponent, className)} style={style}>
      {`Expires ${DateTime.fromISO(value, { locale: 'en' }).toFormat('MM/dd/yy')}`}
    </div>
  );
};

export default memo(Expiration);

const useStyles = createUseStyles({
  expirationComponent: {
    fontSize: '1.3em',
    color: '#333333',
    textTransform: 'uppercase',
  },
});
